// import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './plugins/store/store';
import cookie from './plugins/cookie';
import countrycitystatejson from './plugins/countrycitystatejson/index.js';
import 'es6-promise/auto';
import axios from 'axios';
import commonComponents  from './components/Globals/loader';
import VueHtml2Canvas from 'vue-html2canvas';
import VueGtag from "vue-gtag";

commonComponents.forEach(component => {
  Vue.component(component.name, component);
}); 
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['page'];

/*
  MODEL/VIEW  - Functionality - application logics (process/request data)
  Controller  - Business logics / function execution
*/

Vue.mixin({
  methods: {
      contentDisplayReflectionLanguage: function(programId){
          let programMap =  this.$controller.program.programMap();
          if (programId!==undefined && programMap[programId]){
              let internationalizationDetails = programMap[programId].internationalization;
              let defaultLanguage = internationalizationDetails.default;
              if ( !internationalizationDetails.supported.includes(this.currentSystemLanguage()) ){
                  return defaultLanguage;
              }
          }

          return this.currentSystemLanguage();
      },
      firstMigratedUserLogin: function(){
            const migrationTimestamp = '2020-09-29 01:02:03';
            if (this.$store.getters.user){
                if (this.$store.getters.user.created!==undefined && this.$store.getters.user.updated!==undefined){
                    return this.$store.getters.user.created === migrationTimestamp && this.$store.getters.user.updated === migrationTimestamp;
                }
                
            }
            
            return false;
      },
      countrycitystatejson: function(){
        return countrycitystatejson;
      },
      unlink: function(obj){
        var object = null;
        if(typeof obj=='object'){
          object = JSON.stringify(obj);
          object = JSON.parse(object);
        }

        return object;
      },
      parseJSON: function(object){
        for(let key in object){
          var item = object[key];
          if(typeof item=='string'){
            try{
              item = JSON.parse(item);
              object[key] = item;
            }catch(e){
              // this.customCLog("", e, true)
            }
          }
        }
        return object;
      },
      in_array: function(needle, haystack){
        if( (typeof needle!='undefined') && (typeof haystack!='undefined') ){
          if(typeof needle== 'object'){
            for(let x in needle){
              var hit=false;
              var needleItem=needle[x];
              if(typeof haystack == 'object'){
                for(let z in haystack){
                  if(haystack[z]==needleItem){
                    hit=true;
                    break;
                  }
                }
              }
              if(hit){
                break;
              }
            }
            if(hit){return true;}else{return false;}
          }else{
            if(typeof haystack == 'object'){
              var len = haystack.length;
              for(var z=0;z<len;z++){
                if(haystack[z]==needle){
                  return true;
                }
              }
              return false;	
            } else {
              return (needle == haystack);
            }			
          }
        }else{
          return false;
        }
      },
      sendRequest: function(data){
        var self = this;
        axios.defaults.headers.post['X-CSRF-Token'] = self.$store.getters.csrf;
        axios.defaults.headers.post['jwt'] = self.$store.getters.jwt;
        var request = new Promise((resolve)=>{
            resolve()
        }); 
  
        if(self.$store.getters.csrf || data.action=='csrf'){
          request = new Promise((resolve,reject)=>{
            self.$store.dispatch('busy',true);
            axios.post(self.$store.getters.api+'?action='+data.action+'&call='+data.call,data).then(function(response){
              if(response && response.data && response.data['csrf-check'] && response.data['csrf-check'].result===true){
                resolve(response);
                setTimeout(function(){
                    self.customCLog("dispatch LastActivity API HIT:: ", Math.floor(Date.now() / 1000));
                    self.$store.dispatch('sessionLastActivity',Math.floor(Date.now() / 1000));    
                },500);
              }else{
                self.customCLog('sendRequest: ERROR', response, true)
                reject(response);
              }
                self.$store.dispatch('busy',false);
            })
          })
  
        }else{
          self.customCLog("sendRequest","NO CSRF")
        }
      
        return request;
      },
  
      sendBackgroundRequest: function(data){
        var self = this;
        axios.defaults.headers.post['X-CSRF-Token'] = self.$store.getters.csrf;
        axios.defaults.headers.post['jwt'] = self.$store.getters.jwt;
        var request = new Promise((resolve)=>{
            resolve()
        }); 
  
        if(self.$store.getters.csrf || data.action=='csrf'){
          request = new Promise((resolve,reject)=>{
            axios.post(self.$store.getters.api+'?action='+data.action+'&call='+data.call,data).then(function(response){
              if(response.data['csrf-check'].result===true){
                resolve(response);
              }else{
                reject(response);
              }
            })
          })
        }else{
          self.customCLog("sendBackgroundRequest", "NO CSRF")
        }
        return request;
      },
  
      sendFile: function(data){
        var self = this;
        axios.defaults.headers.post['X-CSRF-Token'] = self.$store.getters.csrf;
        axios.defaults.headers.post['jwt'] = self.$store.getters.jwt;
  
        const request = new Promise((resolve,reject)=>{
          self.$store.dispatch('busy',true);
          axios.post(self.$store.getters.api+'?action=uploadFile',data,{
            onUploadProgress: uploadEvent => {
              self.$store.dispatch('progressBar',Math.round(uploadEvent.loaded / uploadEvent.total * 100));
            }
          }).then(function(response){
            if(response.data['csrf-check'].result===true){
              resolve(response);
            }else{
              reject(response);
            }
            self.$store.dispatch('busy',false);
          })
        })
      
        return request;
      },
      objectLength: function(object){
        var counter = 0;
        for(let i in object){
          typeof i;
          counter++;
        }
        return counter;
      },
      allTrue: function(object){
        var allTrue = true;
        for(let i in object){
            if(object[i]===false){
                allTrue = false
                break;
            }
        }
        return allTrue;
      },
      proper(str){
  
        str = str.toLowerCase().split(' ');
     
        let final = [ ];
     
         for(let  word of str){
           final.push(word.charAt(0).toUpperCase()+ word.slice(1));
         }
     
       return final.join(' ')
      },
      labels: function(key){
        return this.$store.getters.library && this.$store.getters.library.labels && this.$store.getters.library.labels[key] ? 
            this.$store.getters.library.labels[key][this.$store.getters.language] : null;
      },
      currentSystemLanguage: function(){
        return this.$store.getters.language;
      },
      formRules: function(email=null, initialPw=null) {
        function validate_password_strength(password){
          var pass = password!=null ? isStrongPwd(password) : false;

          function isStrongPwd(password) {
          
              var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          
              var lowercase = "abcdefghijklmnopqrstuvwxyz";
          
              var digits = "0123456789";
          
              var splChars ="!@#$%&*()-";
          
              var ucaseFlag = contains(password, uppercase);
          
              var lcaseFlag = contains(password, lowercase);
          
              var digitsFlag = contains(password, digits);
          
              var splCharsFlag = contains(password, splChars);

              var lengthFlag = password.length>=6;

              return (lengthFlag && ucaseFlag && lcaseFlag && digitsFlag && splCharsFlag)
          
          }
          
          function contains(password, allowedChars) {
          
              for (var i = 0; i < password.length; i++) {
          
                      var char = password.charAt(i);
          
                      if (allowedChars.indexOf(char) >= 0) { return true; }
          
                  }
          
              return false;
          }

          if(pass===false){
              // this.dialog = true;
          }
          return pass
        }

        var rules = {
          validFirstName: [
            v => !!v || 'messages > required firstname'
          ],
          validLastName: [
            v => !!v || 'messages > required lastname'
          ],
          validEmail: [
            v => !!v || 'messages > required email',
            v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
                || 'messages > invalid email'
          ],
          validSecondaryEmail: [
            v => /^null$|^(?![\s\S])|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
                || 'messages > invalid email'
          ],
          validConfirmEmail: [
            v => !!v || 'messages > required confirmEmail',
            v => v === email || 'messages > notMatch emails'
          ],
          validCountry: [
            v => !!v || 'messages > required country'
          ],
          validProvinceState: [
            v => !!v || 'messages > required provinceState'
          ],
          validCity: [
            v => !!v || 'messages > required city'
          ],
          validAddress: [
            v => !!v || 'messages > required address'
          ],
          validPostalCode: [
            v => !!v || 'messages > required postalCode'
          ],
          validLanguage: [
            v => !!v || 'messages > required preferLanguage'
          ],
          validPassword: [
            v => !!v || 'messages > required password',
            v => validate_password_strength(v) || "messages > weak password"
          ],
          validConfirmPassword: [
            v => !!v || 'messages > required confirmPassword',
            v => v === initialPw || 'messages > notMatch passwords'
          ],
          validSubject: [
            v => !!v || 'messages > required subject'
          ],
          validProgram: [
            v => !!v || 'messages > required program'
          ],
          validTitle: [
            v => !!v || 'messages > required title'
          ],
          validMessage: [
            v => !!v || 'messages > required contactUsMsg'
          ],
          validSpecialty: [
            v => !!v || 'messages > required specialty'
          ],
          validHcpJobProfession: [
            v => !!v || 'messages > required hcp_job_profession'
          ],
          validTermPolicyConsent: [
            v => v==="Y" || "messages > required terms policy"
          ]
        }
        return rules
      },
      offset: function offset(el) {
          var rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
      },
      /**
       * Show the necessary message in the console within the dev environment only
       * @param {string} message - string message that will show in the log
       * @param {*} data - data that will show in the log
       * @param {boolean} errorSignal
       * @returns 
       */
      customCLog : function(message, data=null, errorSignal=false) {
        const isDev = process.env.NODE_ENV == 'development'
        if (isDev) {
          // if errorSignal is on (true), then use console.error instead. 
          if(errorSignal) {
            console.error(message, data)
            return
          }
          if (data) {
            console.groupCollapsed(message, data)
            console.trace(message, data)
            console.groupEnd()
            return 
          }
          console.groupCollapsed(message)
          console.trace(message)
          console.groupEnd()
          return
        }
      }
  }
});

function guard(to, from, next){
  var user = store.getters.user;
  var matched = to.matched;
  var requiresAuth = false;
  var triggeredBy = null;

  for(var i=0; i<matched.length; i++){
    var route = matched[i];

    if(typeof route.meta.requiresAuth!='undefined' && requiresAuth===false){
      requiresAuth = route.meta.requiresAuth;
      if(requiresAuth===true){
        triggeredBy = route;
      }
    }
  } 
  
  if(requiresAuth===false || requiresAuth===true && user!=false){
    next();
  }else{
    next('/');
    store.dispatch('entryURL',to.fullPath)
  }
}

router.beforeEach(guard);


Vue.use(VueGtag, {
  config: { id: "G-RF9Q08P882" },
  appName: 'Vivomap',
  pageTrackerScreenviewEnabled: true
},router);

let code = new Vue({
  router,
  vuetify,
  store,
  VueHtml2Canvas,
  created: function(){
    this.init();
    if(this.not_support_browser_detection()) {
      this.$router.push({path: '/NotSupport'})
    }
  },
  data: function(){
    return {
      model: null,
      view: null,
      controller: null
    }
  },
  methods: {
    init: function(){
      var self = this;
      self.controller = new self.controller_source(self);
    },

    controller_source: function(self){
      this.security = null;
      this.program = null;
      this.programAdmin = null;
      this.flow = null;
      this.login = null;
      this.view = null;
      this.programAdminQuickAccess = null;
      this.init = function(){
        Vue.prototype.$controller = this;
        Vue.prototype.$sendRequest = self.sendRequest;
        Vue.prototype.$sendBackgroundRequest = self.sendBackgroundRequest;
        Vue.prototype.$sendFile = self.sendFile;
        Vue.prototype.$allTrue = self.allTrue;
        Vue.prototype.$objectLength = self.objectLength;
        Vue.prototype.$cookie = cookie;
        Vue.prototype.$language = self.currentSystemLanguage;
      }
      this.init();
    },

    model_source: function(self){
      this.csrf = new (function() {
        var csrf = this;
        this.request = function(){
          return new Promise((resolve,reject)=>{
            self.sendRequest({
              action: 'csrf',
              call: 'request'
            }).then(function(response){
              reject(response);
            },function(response){
              if(response.data.csrf.request){
                csrf.ready(response.data.csrf.request);            
                resolve(response);
              }else{
                reject(response);
              }
            })
          });
        }

        this.validate = function(){
          return new Promise((resolve,reject)=>{       
            self.$store.dispatch('csrf',self.csrf);
            self.sendRequest({
              action: 'csrf',
              call: 'validate'
            }).then(function(response){
              csrf.ready();
              resolve(response);
            },function(response){
              reject(response);
            })
          });
        }

        this.ready = function(csrf=null){
          if(csrf){
            self.$store.dispatch('csrf',csrf);
          }
          self.$store.dispatch('ready',true);    
        }
      });

      this.jwt = new function(){
        this.validate = function(){
          return new Promise((resolve,reject)=>{
            self.$store.dispatch('ready',false);
            self.sendRequest({
              action: 'user',
              call: 'validate'
            }).then(function(response){
              if(response.data.user.validate){
                resolve(response);
              }else{
                self.$store.dispatch('clear_jwt');
                reject(response);
              }         
              self.$store.dispatch('ready',true);
            })
          });
        }
      }
    },
    not_support_browser_detection: function() {
      var sBrowser, sUsrAg = navigator.userAgent;
      if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
        // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
      } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
        sBrowser = "Samsung Internet";
        // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
      } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        sBrowser = "Opera";
        // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
      } else if (sUsrAg.indexOf("Trident") > -1) {
        sBrowser = "Microsoft Internet Explorer";
        // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
      } else if (sUsrAg.indexOf("Edge") > -1) {
        sBrowser = "Microsoft Edge";
        // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
      } else if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome or Chromium";
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
      } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Apple Safari";
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
      } else {
        sBrowser = "unknown";
      }
      return sBrowser === "Mozilla Firefox" || sBrowser === "Microsoft Internet Explorer";
    }
  },
  computed: {
    csrf: function(){
      return this.$store.getters.csrf ? this.$store.getters.csrf : cookie.get('csrf') ? cookie.get('csrf') : false;
    },
    jwt: function(){
      return this.$store.getters.jwt ? this.$store.getters.jwt : cookie.get('jwt') ? cookie.get('jwt') : false;
    }
  },
  render: h => h(App)
}).$mount('#app')

if(location.hostname=='localhost'){
  window.code = code;
}else{
  code = null;
}